<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="videos">
        <div class="card" :key="index" v-for="(video, index) in videos">
          <video :src="video.url"></video>
          <div class="play" @click="playVideo(video)">
            <img class="white-icon" src="@/assets/img/play.svg" />
          </div>
          <p>{{ video.name }}</p>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="popup" v-if="chosenVideo">
        <div class="offclick" @click="stopVideo()"></div>
        <div class="video-holder">
          <div @click="stopVideo()" class="close">x</div>
          <video controls loop ref="video" :src="chosenVideo"></video>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import firebase from "firebase";
import Swal from "sweetalert2";
import Switches from "vue-switches";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const storage = fb.default.storage;
const auth = fb.default.auth;

export default {
  name: "videos",
  components: {
    Switches,
  },
  data() {
    return {
      chosenVideo: null,
      videos: [],
    };
  },
   firestore() {
    if (this.$store.state.user_doc.hasOwnProperty("affiliate_id")) {
      return {
        videos: db
          .collection("support_video")
          .where("affiliate_id", "==", this.$store.state.user_doc.id)
          .orderBy("order", "asc"),
      };
    } else {
      return {
        videos: db.collection("support_video").orderBy("order", "asc"),
      };
    }
  },
  methods: {
    playVideo(video) {
      this.chosenVideo = video.url;
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.video.play();
      });
    },
    stopVideo() {
      this.$refs.video.pause();
      this.chosenVideo = null;
    },
  },
};
</script>

<style scoped lang="scss">
.videos {
  display: flex;
  flex-wrap: wrap;
  .card {
    width: 300px;
    margin-right: 15px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    video {
      width: 100%;
    }
    .play {
      background: #00bf6f;
      border-radius: 100%;
      height: 50px;
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -25px;
      position: relative;
      border: 5px solid white;
      cursor: pointer;
      z-index: 2;
      img {
        filter: brightness(0) invert(1);
        height: 20px;
      }
    }
    p {
      margin-top: 10px;
      margin-bottom: 0;
    }
  }
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  z-index: 99999;
  justify-content: center;
  align-items: center;
  .offclick {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.65);
    cursor: pointer;
  }
  .video-holder {
    position: relative;
    z-index: 4;
    width: 100%;
    max-width: 750px;
    height: auto;
    video {
      width: 100%;
    }
    .close {
      cursor: pointer;
      width: 100%;
      font-size: 40px;
      color: white;
      text-align: center;
      font-weight: normal;
      margin: 15px 0;
    }
  }
}
</style>
